import { Button, TextField, styled } from "@mui/material";


export const FormWrapper = styled("form")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  backgroundColor: "var(--form-bg-color)",  
  padding: "2rem",
  borderRadius: "8px",
  transition: "background-color 0.3s ease, color 0.3s ease",
}));


export const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    font: '300 1rem/1.7 "Poppins", sans-serif',
    fontSize: "1.4rem",
    backgroundColor: "var(--input-bg-color)",  
    color: "var(--input-text-color)",  
  },
  "& .MuiInputLabel-root": {
    color: "var(--label-color)",  
  },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--input-border-color)",  
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--input-border-hover-color)",  
  },
}));


export const ButtonWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
}));


export const StyledButton = styled(Button)(() => ({
  backgroundColor: "var(--button-bg-color)", 
  color: "var(--button-text-color)",  
  font: '"Poppins", sans-serif',
  fontSize: "1.4rem",
  fontWeight: "normal",
  textTransform: "none",
  padding: "0.8rem 2rem",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "var(--button-hover-bg-color)",  
  },
  "&:disabled": {
    backgroundColor: "var(--button-disabled-bg-color)",  
    color: "var(--button-disabled-text-color)",  
  },
}));
